<template>
  <div id="app">
    <Navigation class="wow bounceInDown"></Navigation>
    <router-view />
    <ComFooter class="wow bounceInUp"></ComFooter>
  </div>
</template>
<script>
import Navigation from "@/components/common/navigation.vue";
import ComFooter from "@/components/common/comFooter.vue";
export default {
  data() {
    return {};
  },
  components: {
    Navigation,
    ComFooter,
  },
};
</script>
<style lang="scss">
@import "./assets/css/common.scss";
#app {
  width: 100%;
  min-width: 1180px;
  position: relative;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
}
.clear::after,
.clear::before {
  display: block;
  content: "";
  clear: both;
}
</style>
